import React, { useState, useEffect } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { paramConverter } from 'modules/common';
import { makeRowColumn, getHeadObj, makeHeadData } from 'lib/commonLib';
import { advrtsTableData } from 'lib/api/media';

import ContentsWrap from 'components/molecules/ContentsWrap';
import BasicTable from 'components/molecules/MbBasicTable';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const useStyles = makeStyles((theme) => ({
  title: {
    flex: '0 0 auto',
    marginBottom: 10,
  },
}));

const MediaAdvrtsTable = ({ params }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const tableHead = {
    headList: [
      {
        id: 'NO',
        label: i18next.t('순위'),
        orderFlag: false,
        type: null,
        format: '@',
      },
      {
        id: 'MEDIA_NAME',
        label: i18next.t('매체명'),
        orderFlag: false,
        type: 'string',
        format: '@',
      },
      {
        id: 'Y_ADVRTS_AMT',
        label: i18next.t('지출금액(어제)'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'Y_ADVRTS_AMT',
        label: i18next.t('지출금액(어제)'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'YY_ADVRTS_AMT',
        label: i18next.t('지출금액(2일전)'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'ADVRTS_AMT_RAF',
        label: i18next.t('지출금액비교'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'SESSION_ROAS',
        label: i18next.t('세션ROAS(전일)'),
        orderFlag: false,
        type: 'number',
        format: '0.0%',
      },
    ],
    order: 'asc',
    orderBy: 'NO',
  };

  const initTableList = [];
  const [tableList, setTableList] = useState(initTableList);
  const initLoading = {
    table: true,
  };
  const [loading, setLoading] = useState(initLoading);
  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  useEffect(() => {
    getData(); // eslint-disable-next-line
  }, [params]);

  const getData = () => {
    setLoading(initLoading);
    setTableList(initTableList);
    advrtsTableData(paramConverter(params))
      .then((response) => {
        const { data } = response.data;
        setTableList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...snackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setLoading({
          ...loading,
          table: false,
        });
      });
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
      message: '',
    });
  };

  const customized = {
    ADVRTS_AMT_RAF: {
      makeBody: (rowObj, headsMap) => {
        const advrtsAmtRaf = getHeadObj(headsMap, 'ADVRTS_AMT_RAF');
        let content, color;
        if (rowObj['ADVRTS_AMT_RAF'] > 0) color = 'blue';
        else color = 'red';
        content = (
          <>
            <span style={{ color: color }}>
              {makeRowColumn(
                rowObj['ADVRTS_AMT_RAF'],
                advrtsAmtRaf.type,
                advrtsAmtRaf.format
              )}
            </span>
          </>
        );
        return content;
      },
    },
  };

  let title = '';

  return (
    <>
      <ContentsWrap loading={loading.table} contentsCount={2}>
        {tableList.map((item, index) => {
          if (index === 0) title = '배너';
          else if (index === 1) title = '아이커버';
          else if (index === 2) title = '브랜드커버';
          else if (index === 3) title = '네이티브';

          return (
            <div key={index + '-' + title}>
              <div className={classes.title}>
                <Typography key={title} variant="h6" id="tableTitle">
                  {t(title)}
                </Typography>
              </div>
              <BasicTable
                sort={tableHead.sort}
                order={tableHead.order}
                list={item}
                headCells={makeHeadData(tableHead.headList)}
                customized={customized}
              />
            </div>
          );
        })}
      </ContentsWrap>
      <SnackbarWrap
        open={snackbar.open}
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleSnackBarClose}
      />
    </>
  );
};

export default MediaAdvrtsTable;
